import type { ReactNode } from 'react';
import './LoginPage.css';

/**
 * Shared split-screen auth chrome — the branded left panel + a right content
 * panel. Introduced with the SC-2336 login page and reused by the SC-2791
 * invite-accept page so both public, pre-session surfaces read as one product.
 * Callers drop their form/content as children into the right panel. The bespoke
 * navy palette lives in LoginPage.css (the documented hardcoded-palette
 * exception to the theme-token rule; SC-2337 reconciles the tokens).
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="login-wrap">
      <div className="login-brand-panel">
        <div className="login-brand-top">
          <div className="login-brand-wordmark">EKOM</div>
          <div className="login-brand-rule" />
        </div>
        <div className="login-brand-bottom">
          <div className="login-brand-headline">
            The resolution layer
            <br />
            for product data.
          </div>
          <div className="login-brand-ned">Normalize · Enrich · Distribute</div>
          <div className="login-brand-compliance">SOC 2 · GDPR · CCPA Compliant</div>
        </div>
      </div>
      <div className="login-form-panel">{children}</div>
    </div>
  );
}
